// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"PrimaryButton_PrimaryButton__ZnfGb","PrimaryButton--rounded":"PrimaryButton_PrimaryButton--rounded__2WdiI"};